import { Navigate, Outlet } from 'react-router'
import { useWallet } from '@/hooks/useWallet.ts'

export function ProtectedRoute() {
  const { isConnected, isConnecting } = useWallet()

  if (isConnecting) {
    return null
  }

  if (!isConnected) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
